import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'cft-holy-grail-grid-sidenav-list',
  template: `
    <h3 *ngIf="level" class="px-2xs pb-2xs text-base font-semibold">{{ level }}</h3>
    <ul [class.pl-sm]="!!level">
      <ng-content select="[cft-holy-grail-grid-sidenav-list-item]"></ng-content>
    </ul>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      @apply block;
    }
  `,
})
export class HolyGrailGridSidenavListComponent {
  @Input() level?: string
}
